

$(document).ready(function () {
    const readAfterBtns = document.querySelectorAll(".js-read-after");

    readAfterBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            var post_id = btn.dataset.pid;
            var user_id = btn.dataset.uid;
            // case not active
            if (!btn.classList.contains("is-active")) {
                btn.classList.add("is-active");
                // case active
            } else {
                btn.classList.remove("is-active");
            }

            $.ajax({
                url: wami_js.ajaxurl,
                data: {
                    action: "wami_follow_this_post",
                    post_id: post_id,
                    user_id: user_id,
                },
                success: function (data) {
                    show_popin_message(
                        "Merci. Cet article est sauvegardé sur votre compte afin que vous puissiez le lire plus tard",
                        "u-show success"
                    );
                },
                error: function (errorThrown) {
                    show_popin_message(
                        "Une erreur est survenue merci de réessayer",
                        "u-show error error-ajax"
                    );
                },
            });
        });
    });
    $("body").on("click", ".logto-read-after, .logto-follow", function (e) {
        e.preventDefault();
        alert("Connectez-vous pour acceder à cette fonctionnalité");
        $(".popin-logto").removeClass("u-hide").addClass("u-show");
    });

    $("body").on("click", ".js-follow-cat", function (e) {
        e.preventDefault();
        var tid = $(this).data("tid");
        var uid = $(this).data("uid");
        var type = $(this).data("type");
        follow_this("follow", tid, uid, $(this), type);
    });
    $("body").on("click", ".js-unfollow-cat", function (e) {
        e.preventDefault();
        var tid = $(this).data("tid");
        var uid = $(this).data("uid");
        var type = $(this).data("type");
        follow_this("unfollow", tid, uid, $(this), type);
    });

    $("body").on("click", ".c-login--connected", function (e) {
        var uid = $(this).data("uid");
        $.ajax({
            url: wami_js.ajaxurl,
            data: {
                action: "wami_update_lastconnect_subscriber",
                user_id: uid,
            },
            success: function (data) {
                //var obj = jQuery.parseJSON(data);
                //console.log(obj);
            },
            error: function (errorThrown) {
                show_popin_message(
                    "Une erreur est survenue (2)",
                    "u-show error error-ajax"
                );
            },
        });
    });

    function follow_this(follow, tax_id, user_id, btn, tax_type) {
        var message = false;
        //console.log('on clique sur ID : '+tax_id);
        $.ajax({
            url: wami_js.ajaxurl,
            data: {
                action: "wami_follow_this_tax",
                follow: follow,
                tax_id: tax_id,
                tax_type: tax_type,
                user_id: user_id,
            },
            success: function (data) {
                var obj = jQuery.parseJSON(data);
                //console.log(obj);
                if ($("body").hasClass("single-post")) {
                    if (follow == "unfollow") {
                        $(".js-follow-cat").each(function () {
                            $(this).removeClass("u-hide");
                        });
                        $(".js-unfollow-cat").each(function () {
                            $(this).addClass("u-hide");
                        });
                    } else {
                        $(".js-unfollow-cat").each(function () {
                            $(this).removeClass("u-hide");
                        });
                        $(".js-follow-cat").each(function () {
                            $(this).addClass("u-hide");
                        });
                    }
                    message =
                        "Merci, cette thématique vient d'etre ajoutée à votre compte.";
                } else if (
                    btn.hasClass("thematique_link") &&
                    btn.closest("div").find(".js-unfollow-cat").length
                ) {
                    btn.addClass("u-hide");
                    if (follow == "unfollow")
                        btn.closest("div")
                            .find(".js-follow-cat")
                            .removeClass("u-hide");
                    else
                        btn.closest("div")
                            .find(".js-unfollow-cat")
                            .removeClass("u-hide");
                    message =
                        "Merci, cette thématique vient d'etre retirée de votre compte.";
                } else if (btn.closest("div").find(".js-unfollow-cat").length) {
                    btn.addClass("u-hide");
                    if (follow == "unfollow")
                        $(".js-follow-cat").removeClass("u-hide");
                    else $(".js-unfollow-cat").removeClass("u-hide");
                    message =
                        "Merci, cette thématique vient d'etre retirée de votre compte.";
                }
                show_popin_message(message, "u-show success");
            },
            error: function (errorThrown) {
                show_popin_message(
                    "Une erreur est survenue merci de réessayer",
                    "u-show error error-ajax"
                );
            },
        });
    }

    function show_popin_message(message, classes) {
        if ($("#popin-js-message").length) {
            $("#popin-js-message .js-content").html(message);
            $("#popin-js-message").addClass(classes).removeClass("u-hide");
            setTimeout(function () {
                $("#popin-js-message").removeClass(classes).addClass("u-hide");
                $("#popin-js-message .js-content").html();
            }, 3000);
        }
    }

});
